import script from "./ProductItem.vue?vue&type=script&setup=true&lang=js"
export * from "./ProductItem.vue?vue&type=script&setup=true&lang=js"

import "./ProductItem.vue?vue&type=style&index=0&id=c345ba50&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c345ba50"]])

export default __exports__